// Live AI-assistant conversation fetched from the backend, which reads the file
// the machine-side python writes during a session (GET /assistant). Reuses the
// same loopback backend base the tool table / probe endpoints use.
import { API_BASE } from '@/types/machine.types';

/** One conversation message as written into assistant.rownd. */
export interface AssistantMessage {
  readonly id: number;
  readonly sender: 'user' | 'assistant';
  readonly name: string;
  readonly timestamp: string;
  readonly content: string;
}

/** Reads the live conversation, keeping only user/assistant messages. Throws on
 *  network failure so the caller can keep the last-known conversation. */
export async function fetchAssistant(): Promise<AssistantMessage[]> {
  const res = await fetch(`${API_BASE}/assistant`);
  if (!res.ok) throw new Error(`GET /assistant ${res.status.toString()}`);
  const data = (await res.json()) as { messages?: AssistantMessage[] };
  return (data.messages ?? []).filter((m) => m.sender === 'user' || m.sender === 'assistant');
}
